export function getParams(state) {
    return state.params
}

export function ListDataSheetsTable(state) {
    return state.tableDataSheets;
}


// WEBPACK FOOTER //
// ./src/modules/data_sheet/getters.js